import React, { useState, useEffect, useRef } from 'react';
import AuthUser from '../../../pageauth/AuthUser';
import PuenteApi from '../../../pageauth/PuenteApi';
import Mensaje from '../../../Mensaje';
import { useLocation, useNavigate } from 'react-router-dom';
import { requestForToken } from '../../../firebase-config';

import TiradaAlBuzonModal from '../submoduloscomunes/TiradaAlBuzon/TiradaAlBuzonModal'; // Ajusta la ruta si es necesario
import BuscarProductoModal from '../submoduloscomunes/BuscarProducto/BuscarProductoModal'; // Importar el nuevo modal
import BuscarEmpleadoModal from '../submoduloscomunes/BuscarEmpleado/BuscarEmpleadoModal';
import BuscarClienteModal from '../submoduloscomunes/BuscarCliente/BuscarClienteModal';
import SeleccionarPagoModal from '../submoduloscomunes/SeleccionarPago/SeleccionarPagoModal';
import ClienteModal from '../submoduloscomunes/ClienteModal/ClienteModal';
import ListaDespachosModal from './submodulos/ListaDespachos/ListaDespachosModal';
import ReporteStockModal from '../submoduloscomunes/ReporteStock/ReporteStockModal';
import CierreTurnoModal from '../submoduloscomunes/CierreDeTurnos/CierreTurnoModal';

import Swal from 'sweetalert2';
import Cargando from '../../../Cargando';
import GenerarPdf from '../submoduloscomunes/GeneradorPdf/GenerarPDF';

export const CuerpoHomePlaya = () => {
    require('./CuerpoHomePlaya.css');
    const navigate = useNavigate();
    const { SetMensaje } = Mensaje();
    const { StartCargando, StopCargando } = Cargando()
    const { CerrarSession, VerificarPassEmpleado, ObtenerUltimaFacturaArca, ObtenerUltimoRemito, ObtenerProductosPorCodigo, TestEndPoint, IniciarTransaccion, imprimirticket, CancelarTransaccion, TerminarTransaccion, GenerarFactura, ObtenerUltimaComanda, ObtenerTransaccionesTurno, reimprimirticket } = PuenteApi()
    const { getModule, getModuleSector, getApodoSector, getPuntoDeVenta } = AuthUser()
    const { ReporteTransacciones } = GenerarPdf();

    const PuntoDeVenta_local = getPuntoDeVenta();

    const [showTiradaModal, setShowTiradaModal] = useState(false);
    const [showBuscarProductoModal, setShowBuscarProductoModal] = useState(false);
    const [showBuscarEmpleadoModal, setShowBuscarEmpleadoModal] = useState(false);
    const [showBuscarClienteModal, setShowBuscarClienteModal] = useState(false);
    const [showClienteModal, setShowClienteModal] = useState(false);
    const [showPagoModal, setShowPagoModal] = useState(false);
    const [showDespachosModal, setShowDespachosModal] = useState(false);
    const [isReporteStockVisible, setIsReporteStockVisible] = useState(false);
    const [showCierreTurnoModal, setShowCierreTurnoModal] = useState(false);


    const [idtransaccion, setidtransaccion] = useState('');
    const [facturaoremito, setfacturaoremito] = useState('');
    const [comentarioRemito, setComentarioRemito] = useState('');
    const [patente, setPatente] = useState('');

    const [operario, setOperario] = useState('');
    const [operarioID, setOperarioID] = useState('');
    const [tipoComanda, setTipoComanda] = useState('TICKET-FACTURA');

    const [clientecompleto, setClienteCompleto] = useState(null);
    const [cliente, setCliente] = useState('1');
    const [cuit, setCuit] = useState('20-00000000-1');
    const [PV, setPV] = useState(
        PuntoDeVenta_local ? String(PuntoDeVenta_local).padStart(4, '0') : '0000'
    );
    const [NumeroFactura, setNumeroFactura] = useState('00000000');
    const [LetraFactura, setLetraFactura] = useState('X');
    const [DomicilioCliente, setDomicilioCliente] = useState('SELECCIONE UN CLIENTE');
    const [CondicionIVA, setCondicionIVA] = useState('NO DISPONIBLE');


    const [items, setItems] = useState([]);
    const [nuevo, setNuevo] = useState({
        codigo: "",
        descripcion: "",
        cantidad: "",
        precio: "",
    });


    function isValidIva(iva) {
        return /^(\d+(\.\d+)?)%$/.test(iva);
    }

    const totalFactura = items.reduce((acc, it) => acc + it.total, 0);
    const ivaInsc = items.reduce((acc, it) => {
        if (isValidIva(it.iva)) {
            const ivaPorcentaje = parseFloat(it.iva) / 100;
            const ivaItem = it.total * ivaPorcentaje / (1 + ivaPorcentaje);
            return acc + ivaItem;
        }
        return acc;
    }, 0);
    const netoGravado = totalFactura - ivaInsc;


    const ivaGrouped = items.reduce((acc, it) => {
        if (isValidIva(it.iva)) {
            const ivaPorcentaje = parseFloat(it.iva) / 100;

            const baseImponible = it.total / (1 + ivaPorcentaje); // Base imponible = Total / (1 + %IVA)

            const importe = baseImponible * ivaPorcentaje;

            const baseImponibleRedondeada = Math.round(baseImponible * 100) / 100;
            const importeRedondeado = Math.round(importe * 100) / 100;
            if (acc[it.iva]) {
                acc[it.iva].base_imponible += baseImponibleRedondeada;
                acc[it.iva].importe += importeRedondeado;
            } else {
                acc[it.iva] = {
                    porcentaje_iva: it.iva,
                    base_imponible: baseImponibleRedondeada,
                    importe: importeRedondeado
                };
            }
        }
        return acc;
    }, {});


    const ivaArray = Object.values(ivaGrouped);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const handleTiradasAlBuzon = () => {
        setShowTiradaModal(true);
    };

    const handleCloseTiradaModal = () => {
        setShowTiradaModal(false);
    };

    const procesarCodigoBarra = async (codigoBarra) => {
        try {
            if (tipoComanda == 'REMITO' && cliente == "1") {
                SetMensaje("Error", "Debe seleccionar un clientes antes de buscar un producto", 3000);
                return;
            } else {

                const modulo = await getModule();
                if (tipoComanda == 'REMITO' && modulo == 'Playa' && clientecompleto.playa == false) {
                    SetMensaje("Error", "El cliente no tiene habilitado articulos de playa para realizar remitos", 3000);
                    return;
                } else {
                    if (tipoComanda == 'REMITO' && modulo == 'Shop' && clientecompleto.minimercado == false) {
                        SetMensaje("Error", "El cliente no tiene habilitado articulos de shop para realizar remitos", 3000);
                        return;
                    }
                }
            }
            const response = await ObtenerProductosPorCodigo(codigoBarra);

            if (response) {
                const existingProductIndex = items.findIndex(
                    (item) => item.codigo === response.sku && item.precio === parseFloat(response.precio)
                );

                if (existingProductIndex !== -1) {
                    const updatedItems = [...items];
                    updatedItems[existingProductIndex].cantidad += parseFloat(1);
                    updatedItems[existingProductIndex].total = updatedItems[existingProductIndex].cantidad * updatedItems[existingProductIndex].precio;

                    setItems(updatedItems);
                } else {
                    const cantidad = parseFloat(1);
                    const precio = parseFloat(response.precio);
                    const total = cantidad * precio;

                    // setItems(prevItems => [...prevItems, { ...response, cantidad, precio, total }]);


                    //             const cantidad = parseFloat(selectedDespacho.litros.replace(',', '.'));
                    // const precio = parseFloat(selectedDespacho.importe.replace(',', '.'))/parseFloat(selectedDespacho.litros.replace(',', '.'));
                    // const total = parseFloat(selectedDespacho.importe.replace(',', '.'));
                    const codigo = response.sku;
                    const descripcion = response.descripcion;
                    const iva = response.iva;

                    setItems(prevItems => [...prevItems, { codigo, descripcion, cantidad, precio, total, iva }]);
                }

                setNuevo({ codigo: "", descripcion: "", cantidad: "", precio: "" });
            }
        } catch (error) {
            SetMensaje("Error", "Hubo un problema con la solicitud", 3000);
        }
    };

    const [selectedIndex, setSelectedIndex] = useState(null); // Estado para seleccionar la fila
    const [scanBuffer, setScanBuffer] = useState('');
    const scanBufferRef = useRef('');

    const reimprimirticket_local = async () => {
        const response = await reimprimirticket();
    }

    const handleKeyDown = async (event) => {
        // Bloqueo de atajos si hay modales abiertos
        if (showTiradaModal || showBuscarProductoModal || showBuscarEmpleadoModal || showBuscarClienteModal || showDespachosModal || showPagoModal || showClienteModal || showCierreTurnoModal) {
            return;
        }

        // --- A. LÓGICA DE ACUMULACIÓN (PRIMERO) ---
        // Usamos .current para acceder y modificar el valor de forma síncrona
        if (event.key.length === 1 && !event.metaKey && !event.ctrlKey && !event.altKey) {
            scanBufferRef.current += event.key;
            // No hay 'return'
        }

        // --- B. LÓGICA DE PROCESAMIENTO CON ENTER (SEGUNDO) ---

        if (event.key === 'Enter') {
            event.preventDefault();

            if (scanBufferRef.current.length > 0) {
                const codigoBarra = scanBufferRef.current;
                await procesarCodigoBarra(codigoBarra);
                scanBufferRef.current = '';
            } else {
                console.log('Enter presionado sin buffer de escaneo. Comportamiento normal o buffer reseteado.');
            }
            return;
        }

        // --- C. LÓGICA DE ATACARJOS EXISTENTES (TERCERO) ---
        if (event.key === 'ArrowDown') {
            setSelectedIndex((prevIndex) => (prevIndex === null ? 0 : Math.min(items.length - 1, prevIndex + 1)));
            setScanBuffer('');
        } else if (event.key === 'ArrowUp') {
            setSelectedIndex((prevIndex) => (prevIndex === null ? 0 : Math.max(0, prevIndex - 1)));
            setScanBuffer('');
        } else if (event.key === 'Escape' && selectedIndex !== null) {
            eliminarFila(selectedIndex);
            setSelectedIndex(null);
            setScanBuffer('');
        } else if (event.key === 'F5') {
            event.preventDefault();  // Prevenir la acción predeterminada de F5 (recargar la página)
            if (tipoComanda == 'REMITO' && cliente == "1") {
                SetMensaje("Error", "Debe seleccionar un clientes antes de buscar un producto", 3000);
                return;
            } else {

                const modulo = await getModule();
                if (tipoComanda == 'REMITO' && modulo == 'Playa' && clientecompleto.playa == false) {
                    SetMensaje("Error", "El cliente no tiene habilitado articulos de playa para realizar remitos", 3000);
                    return;
                } else {
                    if (tipoComanda == 'REMITO' && modulo == 'Shop' && clientecompleto.minimercado == false) {
                        SetMensaje("Error", "El cliente no tiene habilitado articulos de shop para realizar remitos", 3000);
                        return;
                    } else {
                        setShowBuscarProductoModal(true);
                    }
                }
            }
            setScanBuffer('');
        } else if (event.key === 'F11') {
            event.preventDefault();  // Prevenir la acción predeterminada de F5 (recargar la página)
            setShowBuscarClienteModal(true);
            setScanBuffer('');
        } else if (event.key === 'F9') {
            event.preventDefault();
            reimprimirticket_local();
        } else {
            if (scanBuffer.length > 0) {
                setScanBuffer('');
            }
        }
    };

    const handleKeyDown2 = async (event) => {
        if (showTiradaModal || showBuscarProductoModal || showBuscarEmpleadoModal || showBuscarClienteModal || showDespachosModal || showPagoModal || showClienteModal || showCierreTurnoModal) {
            return;
        }
        if (event.altKey && (event.key === 'n' || event.key === 'N')) {
            event.preventDefault();
            if (tipoComanda == 'REMITO') {
                SetMensaje("Error", "No se puede realizar comanda de un REMITO", 3000);
                return;
            }

            if (items.length == 0) {
                SetMensaje("Error", "Se debe seleccionar al menos un producto", 3000);
                return;
            }

            if (tipoComanda != 'TICKET-FACTURA') {
                const result = await Swal.fire({
                    title: 'Comanda',
                    text: "¿Seguro que desea cambiar a modo comanda?",
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sí',
                    cancelButtonText: 'No',
                    reverseButtons: true,
                    customClass: {
                        popup: 'popup-custom-class'
                    },
                });

                if (result.isConfirmed) {
                } else {
                    return;
                }
            }

            const resultado = await ObtenerUltimaComanda();
            if (resultado) {
                let siguiente_comanda = resultado + 1;
                setPV(PuntoDeVenta_local.toString().padStart(4, '0'));
                setNumeroFactura(siguiente_comanda.toString().padStart(8, '0'));
            } else {
                Swal.fire({
                    title: "Error en el sistema de gestion!",
                    text: "Puede ser que la comanda no se guarde o registre correctamente",
                    icon: "error",
                    draggable: true
                });
            }
            setTipoComanda('COMANDA');
            setCondicionIVA('NO DISPONIBLE');
            setLetraFactura('X');
            setClienteCompleto({ "nombre": "INDEFINIDO" });
            setShowBuscarEmpleadoModal(true);
        }
    };

    const proceder_comanda = async () => {
        if (items.length == 0) {
            SetMensaje("Error", "Se debe seleccionar al menos un producto", 3000);
            return;
        }
        if (tipoComanda == 'FACTURA' || tipoComanda == 'TICKET' || tipoComanda == 'REMITO') {
            if (tipoComanda == 'REMITO') {
                if (totalFactura > clientecompleto.credito_disponible) {

                    Swal.fire(
                        'Error en crédito disponible',
                        "El total es mayor al credito disponible del cliente. <br> Crédito disponible: <b>$" + clientecompleto.credito_disponible + "</b> <br> Total de la comanda: <b>$" + totalFactura + "</b>",
                        'error'
                    );
                    return;
                } else {
                    const { value: formValues } = await Swal.fire({
                        title: 'Ingrese un comentario y patente',
                        html: `
                        <input id="swal-input-comment" class="swal2-input" placeholder="Ingrese un comentario..." />
                        <input id="swal-input-patente" class="swal2-input" placeholder="Ingrese la patente..." />
                    `,
                        focusConfirm: false,
                        showCancelButton: false,
                        confirmButtonText: 'Continuar',
                        preConfirm: () => {
                            const comentario = document.getElementById('swal-input-comment').value;
                            const patente = document.getElementById('swal-input-patente').value;

                            // Validar solo la patente
                            if (!patente) {
                                Swal.showValidationMessage('La patente es obligatoria');
                                return false;
                            }

                            return { comentario, patente };
                        }
                    });
                    setComentarioRemito(formValues.comentario);
                    setPatente(formValues.patente);
                    setShowBuscarEmpleadoModal(true);
                }
            } else {
                setShowBuscarEmpleadoModal(true);
            }
        } else {
            SetMensaje("Error", "Debe seleccionar un tipo de factura antes de proceder", 3000);
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [!showBuscarProductoModal, !showBuscarEmpleadoModal, !showBuscarClienteModal, !showDespachosModal, !showPagoModal, items, selectedIndex, tipoComanda, clientecompleto, showClienteModal, showCierreTurnoModal]);
    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown2);

        return () => {
            window.removeEventListener('keydown', handleKeyDown2);
        };
    }, [!showBuscarProductoModal, !showBuscarEmpleadoModal, !showBuscarClienteModal, !showDespachosModal, !showPagoModal, showClienteModal, showCierreTurnoModal, showBuscarProductoModal, items]);


    const eliminarFila = (index) => {
        setItems(items.filter((_, i) => i !== index));
    };

    const handleSelectProduct = (producto) => {
        const existingProductIndex = items.findIndex(
            (item) => item.codigo === producto.codigo && item.precio === parseFloat(producto.precio)
        );

        if (existingProductIndex !== -1) {
            const updatedItems = [...items];
            updatedItems[existingProductIndex].cantidad += parseFloat(producto.cantidad);
            updatedItems[existingProductIndex].total = updatedItems[existingProductIndex].cantidad * updatedItems[existingProductIndex].precio;

            setItems(updatedItems);
        } else {
            const cantidad = parseFloat(producto.cantidad);
            const precio = parseFloat(producto.precio);
            const total = cantidad * precio;
            const iva = producto.iva;

            setItems(prevItems => [...prevItems, { ...producto, cantidad, precio, total, iva }]);
        }

        setNuevo({ codigo: "", descripcion: "", cantidad: "", precio: "" });
    };

    const verificar_empleado = async (empleado, password) => {
        if (items.length == 0) {
            SetMensaje("Error", "Se debe seleccionar al menos un producto");
        } else {
            const resultado = await VerificarPassEmpleado(empleado.nombre_solo, empleado.apellido_solo, empleado.id, password);
            if (resultado != true) {
                return;
            } else {
                setOperario(empleado.nombre);
                setOperarioID(empleado.id);
                if (tipoComanda == 'REMITO') {
                    procesar_remito(empleado.id);
                } else {
                    const resultado = await TestEndPoint();
                    if (resultado == true) {
                        const subtipoticket = {
                            pv: PV,
                            numero: NumeroFactura,
                            letra: LetraFactura,
                            iva: CondicionIVA
                        };
                        const operarioID = empleado.id;
                        const result = await IniciarTransaccion(items, tipoComanda, subtipoticket, clientecompleto, operarioID, totalFactura);
                        if (result) {
                            setidtransaccion(result.transaccion);
                            setfacturaoremito(result.facturaoremito);
                            StopCargando();
                            setShowPagoModal(true);
                        } else {
                            return false;
                        }
                    } else {
                        // StopCargando();
                        // SetMensaje("Error", "Error en el sistema de gestion", 3000);
                        return false;
                    }
                }
            }
        }
    }

    const procesar_remito = async (empleadoid) => {
        StartCargando("Prosesando remito");
        const resultado = await TestEndPoint();
        if (resultado == true) {
            const subtipoticket = {
                pv: PV,
                numero: NumeroFactura,
                letra: LetraFactura,
                iva: CondicionIVA
            };
            const operarioID = empleadoid;
            const result = await IniciarTransaccion(items, tipoComanda, subtipoticket, clientecompleto, operarioID, totalFactura, comentarioRemito, patente);
            if (result) {
                const idtransaccion = result.transaccion;
                const facturaoremito = result.facturaoremito;
                const mediopago = {};
                StopCargando();
                StartCargando("Imprimiendo ticket...");
                imprimir_ticket(items, tipoComanda, subtipoticket, clientecompleto, operarioID, totalFactura, mediopago, idtransaccion, facturaoremito, comentarioRemito, patente);
            } else {
                // StopCargando();
                // SetMensaje("Error", "Error en el sistema de gestion", 3000);
                return false;
            }
        } else {
            // StopCargando();
            // SetMensaje("Error", "Error en el sistema de gestion", 3000);
            return false;
        }
    };

    const finalizar_transaccion = async (operarioID, totalFactura, idtransaccion, facturaoremito, mediopago, tipoComanda, mensajefin) => {
        StartCargando("Procesando...");
        const resultado = await TerminarTransaccion(operarioID, totalFactura, idtransaccion, facturaoremito, mediopago, tipoComanda, mensajefin);
        if (resultado == true) {
            StopCargando();
            limpiar_comanda();
            Swal.fire({
                title: "Operacion realizada con exito!",
                icon: "success",
                draggable: true
            });
            return true;
        } else {
            StopCargando();
            SetMensaje("Error", "Error al procesar transaccion, vuelva a intentar.");
            limpiar_comanda();
            return false;
        }

    };

    const imprimir_ticket = async (items, tipoComanda, subtipoticket, clientecompleto, operarioID, totalFactura, mediopago, idtransaccion, facturaoremito, comentarioRemito, patente) => {
        const resultado = await imprimirticket(items, tipoComanda, subtipoticket, clientecompleto, operarioID, totalFactura, mediopago, idtransaccion, facturaoremito, comentarioRemito, patente);
        if (resultado == true) {
            StopCargando();
            finalizar_transaccion(operarioID, totalFactura, idtransaccion, facturaoremito, mediopago, tipoComanda, "fin");
        } else {
            StopCargando();
            Swal.fire({
                title: "Error al imprimir ticket!",
                icon: "error",
                draggable: true,
                showCancelButton: true,
                confirmButtonText: 'Reintentar',
                cancelButtonText: 'Cancelar operación',
                showDenyButton: true,
                denyButtonText: 'Continuar sin imprimir',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    imprimir_ticket(items, tipoComanda, subtipoticket, clientecompleto, operarioID, totalFactura, mediopago, idtransaccion, facturaoremito, comentarioRemito, patente);
                } else if (result.isDenied) {
                    // console.log("Descargar PDF");
                    finalizar_transaccion(operarioID, totalFactura, idtransaccion, facturaoremito, mediopago, tipoComanda, "fin_sin_imprimir");
                } else if (result.isDismissed) {
                    StartCargando("Cancelando transaccion");
                    const resultadocancelado = await CancelarTransaccion(tipoComanda, idtransaccion, facturaoremito);
                    if (resultadocancelado == true) {
                        StopCargando();
                        SetMensaje("OK", "Transaccion cancelada con exito", 3000);
                    } else {
                        StopCargando();
                        SetMensaje("Error", "Error al cancelar transaccion", 3000);
                    }
                }
            });
        }
    };


    const funcion_local_GenerarFactura = async (mediopagos) => {
        const respuesta = await GenerarFactura("productos", PV, tipoComanda, LetraFactura, clientecompleto, ivaArray, idtransaccion, totalFactura, netoGravado);
        if (respuesta) {
            const cae = respuesta.cae;
            const fecha_vencimiento_cae = respuesta.cae_expiration_date;
            const numerofac = respuesta.invoice_from;
            // console.log("cae: " + cae + " fecha: " +fecha_vencimiento_cae + " numfac: "+ numerofac)
            const subtipoticket = {
                pv: PV,
                numero: numerofac.toString().padStart(8, '0'),
                letra: LetraFactura,
                iva: CondicionIVA,
                cae: cae,
                caevenc: fecha_vencimiento_cae.replace(/-/g, ""),
                neto: netoGravado,
                iva: ivaInsc
            };
            StopCargando();
            StartCargando("Imprimiendo ticket...");
            imprimir_ticket(items, tipoComanda, subtipoticket, clientecompleto, operarioID, totalFactura, mediopagos, idtransaccion, facturaoremito);
        } else {
            Swal.fire({
                title: "Error al generar factura!",
                icon: "error",
                draggable: true,
                showCancelButton: true,
                confirmButtonText: 'Reintentar',
                cancelButtonText: 'Cancelar operación',
                showDenyButton: true,
                denyButtonText: 'Continuar sin generar factura',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    funcion_local_GenerarFactura(mediopagos);
                } else if (result.isDenied) {
                    finalizar_transaccion(operarioID, totalFactura, idtransaccion, facturaoremito, mediopagos, tipoComanda, "fin_sin_factura");
                } else if (result.isDismissed) {
                    StartCargando("Cancelando transaccion");
                    const resultadocancelado = await CancelarTransaccion(tipoComanda, idtransaccion, facturaoremito);
                    if (resultadocancelado == true) {
                        StopCargando();
                        SetMensaje("OK", "Transaccion cancelada con exito", 3000);
                    } else {
                        StopCargando();
                        SetMensaje("Error", "Error al cancelar transaccion", 3000);
                    }
                }
            });
        }
    };

    const handleClosePagoModal = async (operacion, mediopagos) => {
        if (operacion == "cancel") {
            setShowPagoModal(false);
            return;
        }
        setShowPagoModal(false);
        if (tipoComanda == "COMANDA") {
            const subtipoticket = {
                pv: PV,
                numero: NumeroFactura,
                letra: LetraFactura,
                iva: CondicionIVA,
                cae: "0",
                caevenc: "20251119"
            };
            imprimir_ticket(items, tipoComanda, subtipoticket, clientecompleto, operarioID, totalFactura, mediopagos, idtransaccion, facturaoremito);
        } else {
            funcion_local_GenerarFactura(mediopagos);
        }
    };

    const limpiar_comanda = () => {
        setShowPagoModal(false);
        setItems([]);
        setCliente('1');
        setCondicionIVA('NO DISPONIBLE');
        setCuit('20-00000000-1');
        setPV('0001');
        setNumeroFactura('00000000');
        setLetraFactura('x');
        setTipoComanda('TICKET-FACTURA');
        setDomicilioCliente('SELECCIONE UN CLIENTE');
    }

    const cancelar_comanda = async () => {
        if (items.length == 0 && cliente == '1' && tipoComanda != "REMITO") {
            return;
        }
        const result = await Swal.fire({
            title: 'Cancelar Comanda',
            text: "¿Desea cancelar esta comanda?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                popup: 'popup-custom-class' // Puedes personalizar el estilo CSS aquí
            },
        });

        if (result.isConfirmed) {
            limpiar_comanda();
        }
    }

    const handleSelectEmpleado = (empleado) => {

        Swal.fire({
            title: 'Ingrese su contraseña',
            input: 'password',
            inputLabel: empleado.nombre,
            inputPlaceholder: 'Ingrese su contraseña aqui...',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar',
            inputValidator: (value) => {
                if (!value) {
                    return 'Necesita escribir una contraseña!';
                }
            }
        }).then((result) => {
            if (result.isConfirmed) {
                verificar_empleado(empleado, result.value);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire('Operacion Cancelada', '', 'info');
            }
        });
    };

    const handleSelectCliente = async (cliente) => {
        setClienteCompleto(cliente);
        setCliente(cliente.nombre);
        setCuit(cliente.cuit);
        setDomicilioCliente(cliente.domicilio);
        setShowBuscarClienteModal(false);

        if (LetraFactura === 'r' || LetraFactura === 'R') {
            // console.log(cliente);
            Swal.fire(
                'Crédito disponible',
                'El cliente <b>' + cliente.nombre + '</b> contiene:<br> <b>$' +
                cliente.credito_disponible + '</b><br>de crédito disponible',
                'info'
            );

        } else {
            if (PuntoDeVenta_local == null) {
                Swal.fire({
                    title: "Error al facturar",
                    text: "Establezca un punto de venta en la configuracion del modulo",
                    icon: "error",
                    draggable: true
                });
                return;
            }
            if (cliente.letra_factura === 'A' || cliente.letra_factura === 'B' || cliente.letra_factura === 'C') {
                setTipoComanda('FACTURA');
            } else {
                setTipoComanda('TICKET');
            }
            setCondicionIVA(cliente.condicion_iva);
            setLetraFactura(cliente.letra_factura);
            const resultado = await ObtenerUltimaFacturaArca(cliente.letra_factura, PuntoDeVenta_local);
            if (resultado.success == true) {
                let siguiente_numero_factura = resultado.ultimo_numero_factura + 1;
                setPV(PuntoDeVenta_local.toString().padStart(4, '0'));
                setNumeroFactura(siguiente_numero_factura.toString().padStart(8, '0'));
            } else {
                Swal.fire({
                    title: "Error en el servidor de ARCA!",
                    text: "NO SE PUEDE CONTINUAR CON FACTURAS A-B",
                    icon: "error",
                    draggable: true
                });
            }
        }

    };

    const handleABMClientes = () => {
        // SetMensaje("OK", "Has accedido a Clientes", 3000);
        setShowClienteModal(true);
    };

    const handleFacturasAB = async () => {
        if (LetraFactura === "R" || LetraFactura === "r") {
            SetMensaje("Error", "No se puede acceder a facturas estando en remito. Por favor, cancele la operacion previa.");
        } else {
            if (PuntoDeVenta_local == null) {
                Swal.fire({
                    title: "Error al facturar",
                    text: "Establezca un punto de venta en la configuracion del modulo",
                    icon: "error",
                    draggable: true
                });
                return;
            }
            let LetraFactura_local = "B";
            if (LetraFactura === 'x' || LetraFactura === 'X') {
                LetraFactura_local = "B";
            } else {
                if (cliente !== 'CONSUMIDOR FINAL') {
                    if (LetraFactura === 'a' || LetraFactura === 'A') {
                        LetraFactura_local = "B";
                    } else {
                        if (LetraFactura === 'b' || LetraFactura === 'B') {
                            LetraFactura_local = "C";
                        } else {
                            LetraFactura_local = "A";
                        }
                    }
                }
            }

            const resultado = await ObtenerUltimaFacturaArca(LetraFactura_local, PuntoDeVenta_local);
            if (resultado.success == true) {
                let siguiente_numero_factura = resultado.ultimo_numero_factura + 1;
                if (LetraFactura === 'x' || LetraFactura === 'X') {
                    setCliente('CONSUMIDOR FINAL');
                    setCondicionIVA('CONSUMIDOR FINAL');
                    setCuit('20-00000000-1');
                    setTipoComanda('TICKET');
                    setClienteCompleto({ "nombre": "CONSUMIDOR FINAL", condicion_iva: "CONSUMIDOR FINAL" });
                }
                setPV(PuntoDeVenta_local.toString().padStart(4, '0'));
                setNumeroFactura(siguiente_numero_factura.toString().padStart(8, '0'));
                setLetraFactura(LetraFactura_local);
            } else {
                Swal.fire({
                    title: "Error en el servidor de ARCA!",
                    text: "No se pudo conectar con el servidor de ARCA, intente nuevamente mas tarde. NO SE PUEDE CONTINUAR CON FACTURAS A-B",
                    icon: "error",
                    draggable: true
                });
            }
        }
    };

    const handleListadoDeStock = () => {
        // SetMensaje("OK", "Has accedido a Listado de Stock", 3000);
        handleOpenReporte();
    };

    const handleVolverAlInicio = async () => {
        await CerrarSession();
        navigate('/');
    };

    const handleDespachos = async () => {

        if (tipoComanda == 'REMITO' && cliente == "1") {
            SetMensaje("Error", "Debe seleccionar un clientes antes de buscar un despacho", 3000);
            return;
        } else {
            const modulo = await getModule();
            if (tipoComanda == 'REMITO' && modulo == 'Playa' && clientecompleto.combustible == false) {
                SetMensaje("Error", "El cliente no tiene habilitado articulos de despacho para realizar remitos", 3000);
                return;
            } else {
                setShowDespachosModal(true);
            }
        }
    };

    const handleRemitos = async () => {
        if (cliente != '1') {
            SetMensaje("Error", "Para ingresar a la seccion remitos, no debe haber ningun cliente seleccionado", 5000);
            return;
        }
        if (items.length == 0) {

            try {
                const response = await ObtenerUltimoRemito();
                if (response != -1) {
                    const numero = parseInt(response) + 1;
                    setNumeroFactura(numero.toString().padStart(8, '0'));
                    setLetraFactura('R');
                    setPV(PuntoDeVenta_local.toString().padStart(4, '0'));
                    setTipoComanda('REMITO');
                    return;
                } else {
                    SetMensaje("Error", "No se encontro el ultimo remito", 3000);
                    return;
                }
            } catch (error) {
                SetMensaje("Error", "Hubo un problema con la solicitud", 3000);
                return;
            }

        } else {
            SetMensaje("Error", "Para ingresar a la seccion remitos, no debe haber ningun producto seleccionado", 5000);
            return;
        }
    };

    const handlePagoAProveedores = () => {
        SetMensaje("Error", "No se puede acceder a esta seccion en modulo playa", 3000);
        // imprimirViaSerial();
    };

    const handleCierreDeTurno = async () => {
        // SetMensaje("OK", "Has accedido a Cierre De Turno", 3000);
        const result = await Swal.fire({
            title: 'Cierre de turno',
            text: "¿Seguro que desea realizar un cierre de turno?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                popup: 'popup-custom-class' // Puedes personalizar el estilo CSS aquí
            },
        });

        if (result.isConfirmed) {
            setShowCierreTurnoModal(true);
        } else {
            Swal.fire({
                title: "Cierre de turno cancelado",
                icon: "success",
                draggable: true
            });
        }
    };

    const handleArtVariosFacturados = async () => {
        StartCargando("Cargando articulos...");
        const transacciones = await ObtenerTransaccionesTurno();
        if (transacciones) {
            StopCargando();
            await ReporteTransacciones(
                transacciones,
                process.env.REACT_APP_RAZONSOCIAL,
                process.env.REACT_APP_DOMICILIO,
                process.env.REACT_APP_CUIT,
            );
        }
        StopCargando();
    };

    const handleCloseClienteModal = () => {
        setShowClienteModal(false);
    };

    const handleSelectDespacho = (selectedDespacho) => {

        const cantidad = parseFloat(selectedDespacho.litros.replace(',', '.'));
        const precio = parseFloat(selectedDespacho.importe.replace(',', '.')) / parseFloat(selectedDespacho.litros.replace(',', '.'));
        const total = parseFloat(selectedDespacho.importe.replace(',', '.'));
        const codigo = selectedDespacho.codigo;
        const descripcion = selectedDespacho.combustible;
        const manguera = selectedDespacho.manguera;
        const surtidor = selectedDespacho.surtidor;
        const iva = selectedDespacho.iva;

        setItems(prevItems => [...prevItems, { codigo, descripcion, cantidad, precio, total, iva, manguera }]);

        setNuevo({ codigo: "", descripcion: "", cantidad: "", precio: "" });
        setShowDespachosModal(false);
    };

    const handleCloseDespachosModal = () => {
        setShowDespachosModal(false);
    };

    const botonesFila1 = [
        { texto: "Clientes", icono: "fas fa-users text-4xl text-white-500 mb-3", callback: handleABMClientes },
        { texto: "Facturas A-B", icono: "fas fa-file-alt text-4xl text-white-500 mb-3", callback: handleFacturasAB },
        { texto: "Tiradas Al Buzón", icono: "fas fa-envelope-open text-4xl text-white-500 mb-3", callback: handleTiradasAlBuzon },
        { texto: "Listado de Stock", icono: "fas fa-clipboard-list text-4xl text-white-500 mb-3", callback: handleListadoDeStock },
        { texto: "Volver al Inicio", icono: "fas fa-arrow-left text-4xl text-white-500 mb-3", callback: handleVolverAlInicio },
    ];

    const botonesFila2 = [
        { texto: "Despachos", icono: "fas fa-gas-pump text-4xl text-white-500 mb-3", callback: handleDespachos },
        { texto: "Remitos", icono: "fas fa-file-invoice text-4xl text-white-500 mb-3", callback: handleRemitos },
        { texto: "Pago A Proveedores", icono: "fas fa-hand-holding-usd text-4xl text-white-500 mb-3", callback: handlePagoAProveedores },
        { texto: "Cierre De Turno", icono: "fas fa-lock text-4xl text-white-500 mb-3", callback: handleCierreDeTurno },
        { texto: "Art. Varios Facturados", icono: "fas fa-chart-bar text-4xl text-white-500 mb-3", callback: handleArtVariosFacturados },
    ];

    const formatCuit = (cuit) => {
        // Verifica si el CUIT ya está formateado
        if (/^\d{2}-\d{8}-\d{1}$/.test(cuit)) {
            return cuit; // Si ya está formateado, lo retorna tal cual
        }

        // Asegura que el CUIT tenga 11 dígitos y formatea con guiones
        const cuitStr = cuit.toString().padStart(11, '0');  // Asegura que el CUIT tenga 11 dígitos
        return `${cuitStr.slice(0, 2)}-${cuitStr.slice(2, 10)}-${cuitStr.slice(10, 11)}`;
    };

    const handleOpenReporte = () => {
        setIsReporteStockVisible(true);
    };

    const handleCloseReporte = () => {
        setIsReporteStockVisible(false);
    };

    const handleCloseCierreTurno = () => {
        setShowCierreTurnoModal(false);
    };


    return (
        <div className="ventana">

            <TiradaAlBuzonModal
                isVisible={showTiradaModal}
                onClose={handleCloseTiradaModal}
                SetMensaje={SetMensaje} // Pasamos la función de mensaje
            />

            <BuscarProductoModal
                isVisible={showBuscarProductoModal}
                onClose={() => setShowBuscarProductoModal(false)}
                onSelectProduct={handleSelectProduct}
            />

            <BuscarEmpleadoModal
                isVisible={showBuscarEmpleadoModal}
                onClose={() => setShowBuscarEmpleadoModal(false)}
                onSelectempleado={handleSelectEmpleado}
            />

            <SeleccionarPagoModal
                isVisible={showPagoModal}
                onClose={handleClosePagoModal}
                totalFactura={totalFactura}
                SetMensaje={SetMensaje}
                operarioID={operarioID}
            />

            <BuscarClienteModal
                isVisible={showBuscarClienteModal}
                onClose={() => setShowBuscarClienteModal(false)}
                onSelectcliente={handleSelectCliente}
                tipoComanda={tipoComanda}
            />

            <ClienteModal
                isVisible={showClienteModal}
                onClose={handleCloseClienteModal}
                SetMensaje={SetMensaje}
            />

            <ListaDespachosModal
                isVisible={showDespachosModal}
                onSelectdespacho={handleSelectDespacho}
                onClose={handleCloseDespachosModal}
                SetMensaje={SetMensaje}
            />

            <ReporteStockModal
                isVisible={isReporteStockVisible}
                onClose={handleCloseReporte}
                SetMensaje={SetMensaje}
            />

            <CierreTurnoModal
                isVisible={showCierreTurnoModal}
                onClose={handleCloseCierreTurno}
                SetMensaje={SetMensaje}
            />

            {/* FILA SUPERIOR */}
            <div className="barra-superior">
                <div className="fila-botones">
                    {botonesFila1.map((b, i) => (
                        <button key={i} className="boton-menu" onClick={b.callback}>
                            <div className="icono"><i class={b.icono}></i></div>
                            <div className="texto">{b.texto}</div>
                        </button>
                    ))}
                </div>
                <div className="logo-text">{process.env.REACT_APP_NOMBRE}</div>
            </div>

            {/* SEGUNDA FILA */}
            <div className="barra-superior">
                <div className="fila-botones">
                    {botonesFila2.map((b, i) => (
                        <button key={i} className="boton-menu" onClick={b.callback}>
                            <div className="icono"><i class={b.icono}></i></div>
                            <div className="texto">{b.texto}</div>
                        </button>
                    ))}
                </div>
                <div className="apodo-text">{getApodoSector()}</div>
            </div>

            {/* SECCIÓN PRINCIPAL */}
            <div className="panel-principal">
                <div className="bloque-formulario">
                    {/* Columna 1 */}
                    <div className="columna">
                        <label>Comprobante Tipo</label>
                        <input value={tipoComanda} readOnly />

                        <div className="grupo-horizontal">
                            <div>
                                <label>P.V.</label>
                                <input value={PV} readOnly />
                            </div>
                            <div>
                                <label>Número</label>
                                <input value={NumeroFactura} readOnly />
                            </div>
                            <div>
                                <label>Letra</label>
                                <div name="letra" id="letra">{LetraFactura}</div>
                            </div>
                        </div>
                    </div>

                    {/* Columna 2 */}
                    <div className="columna">
                        <label>Cliente</label>
                        <div className="buscador">
                            <input value={cliente} readOnly />
                            <button onClick={() => setShowBuscarClienteModal(true)}>🔍</button>
                        </div>

                        <label>
                            Domicilio <span className="texto-secundario">{DomicilioCliente}</span>
                        </label>


                        <div className="label-y-buscador"> {/* Nuevo contenedor */}
                            <label>Lista de Precios</label>
                            <div className="buscadorgris">
                                <input value="LISTA DE PRECIO BASE" readOnly />
                                <button>🔍</button>
                            </div>
                        </div>

                    </div>

                    {/* Columna 3 */}
                    <div className="columna">
                        <label>CUIT</label>
                        <input value={formatCuit(cuit)} readOnly />
                        <label>Cond. I.V.A</label>
                        <input value={CondicionIVA} readOnly />
                    </div>
                </div>

                {/* TABLA DE PRODUCTOS */}
                <div className="tabla">
                    <div className="encabezado-tabla">
                        <div>Código</div>
                        <div>Descripción</div>
                        <div>Cantidad</div>
                        <div>P. Unitario</div>
                        <div>Total</div>
                        <div></div>
                    </div>

                    {/* Filas ingresadas */}
                    {items.length === 0 ? (
                        <div className="cuerpo-tabla">
                            <div className="marca">{process.env.REACT_APP_NOMBRE} - Sistema de Gestion</div>
                        </div>
                    ) : (
                        <div className="filas">
                            {items.map((it, i) => (
                                <div
                                    key={i}
                                    className={`fila ${selectedIndex === i ? 'selected' : ''}`} // Añadir clase 'selected' si es la fila seleccionada
                                    onClick={() => setSelectedIndex(i)} // Permitir seleccionar la fila al hacer click
                                >
                                    <div>{it.codigo}</div>
                                    <div>{it.descripcion}</div>
                                    <div>
                                        <input
                                            type="number"
                                            value={it.cantidad}
                                            onChange={(e) => {
                                                const newCantidad = parseFloat(e.target.value);
                                                const updatedItems = [...items];
                                                updatedItems[i].cantidad = newCantidad;
                                                updatedItems[i].total = newCantidad * it.precio;  // Recalcular el total
                                                setItems(updatedItems); // Actualizar la lista de items
                                            }}
                                            min="0" // Para evitar cantidades negativas
                                        />
                                    </div>
                                    <div>{it.precio.toFixed(2)}</div>
                                    <div>{it.total.toFixed(2)}</div>
                                    <div>
                                        <button className="btn-eliminar" onClick={() => eliminarFila(i)}>
                                            ❌
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Totales */}
                <div className="totales">
                    {[
                        { titulo: "Neto Gravado", valor: netoGravado.toFixed(2) },
                        { titulo: "No Gravado", valor: "0,000" },  // Puedes agregar más lógica si es necesario
                        { titulo: "Imp. Internos", valor: "0,000" },  // Igual que arriba, se puede agregar lógica según lo que se necesite
                        { titulo: "I.V.A. Insc.", valor: ivaInsc.toFixed(2) },
                        { titulo: "Total Percepciones", valor: "0,000" }, // De nuevo, si tienes lógica para esto, se puede agregar
                        { titulo: "Total a Facturar", valor: totalFactura.toFixed(2) },
                    ].map((total, i) => (
                        <div key={i} className="campo-total">
                            <div className="titulo">{total.titulo}</div>
                            <div className="valor">{total.valor}</div>
                        </div>
                    ))}
                </div>

                {/* Botones de acción */}
                <div className="acciones">
                    <div className="texto-ayuda">
                        Presione F5 para buscar <br />
                        Presione F9 para reinprimir <br />
                        Presione F11 para cambiar el cliente <br />
                        Presione ESC para borrar el ítem seleccionado <br />
                        V{process.env.REACT_APP_VERSION}
                    </div>

                    <div className="botones-finales">
                        <button className="boton-final" onClick={() => cancelar_comanda()}>
                            <div className="icono"><i class="fa fa-times text-1xl text-red-500 mb-3"></i></div>
                            <div className="texto">Cancelar</div>
                        </button>
                        <button className="boton-final" onClick={() => proceder_comanda()}>
                            <div className="icono"><i class="fa fa-check text-1xl text-green-500 mb-3"></i></div>
                            <div className="texto">Ok</div>
                        </button>
                    </div>
                </div>



                {/* <div className="pie">SisGes Playa</div> */}
            </div>
        </div>
    );
}